if (!String.prototype.inArray) {
    String.prototype.inArray = function T(...items) {
        return items.find(x => x === this.toString()) !== undefined;
    };
}
if (!String.prototype.toDate) {
    String.prototype.toDate = function () {
        return new Date(this);
    };
}
if (!String.prototype.splitMany) {
    String.prototype.splitMany = function (...seperators) {
        let items = [this];
        seperators.forEach(seperator => {
            items = [].concat.apply([], items.map(x => x.split(seperator)))
                .filter(x => x);
        });
        return items;
    };
}
if (!String.prototype.toBoolean) {
    String.prototype.toBoolean = function () {
        switch (this.toLowerCase()) {
            case true.toString():
                return true;
            case false.toString():
                return false;
            default:
                throw new Error("Boolean.parse: Cannot convert string to boolean.");
        }
    };
}
if (!String.prototype.contains) {
    String.prototype.contains = function (value) {
        let item = (this) ? this.toLowerCase().trim() : "";
        let v = (value) ? value.toLowerCase().trim() : "";
        return item.indexOf(v) !== -1;
    };
}
if (!String.prototype.appendQuerystring) {
    String.prototype.appendQuerystring = function (param, value) {
        let url = new URL(this, window.location.origin);
        url.searchParams.set(param, value.toString());
        return url.toString();
    };
}
if (!String.prototype.removeQuerystring) {
    String.prototype.removeQuerystring = function (param) {
        let url = new URL(this, window.location.origin);
        let paramKey = this.getQuerystringKey(param);
        url.searchParams.delete(paramKey); // setting your param
        return url.toString();
    };
}
if (!String.prototype.getQuerystringKey) {
    String.prototype.getQuerystringKey = function (param) {
        let url = new URL(this, window.location.origin);
        let params = url.searchParams;
        let keyName = Array.from(params.keys()).find(function (key) {
            return key.toLowerCase() == param.toLowerCase();
        });
        return keyName;
    };
}
if (!String.prototype.truncate) {
    String.prototype.truncate = function (len) {
        let value = this;
        if (value.length > len) {
            value = value.substring(0, len - 3);
            return value + "...";
        }
        return value;
    };
}
//# sourceMappingURL=string.extensions.js.map